import type { FormInstance } from 'antd';

import { ApiProblem } from '@/api/http';
import { problemMessage } from '@/i18n/problem';

/**
 * Ошибка API → подсказки у полей формы (DoD дня 25: «ошибки 409/422 на полях»).
 *
 * 422 от FastAPI несёт `errors[].loc = ['body', 'inn']` — поле известно точно.
 * 409 несёт `code` (`client_exists`, `product_exists`…) — поле задаёт вызывающий картой.
 * Возвращает true, если ошибка показана у поля; иначе её надо показать общим сообщением.
 */
export function applyProblem(
  form: FormInstance,
  error: unknown,
  codeFields: Record<string, string> = {},
): boolean {
  if (!(error instanceof ApiProblem)) return false;
  const known = new Set(Object.keys(form.getFieldsValue() as object)); // поля этой формы
  const fields = new Map<string, string[]>();

  for (const e of error.errors) {
    const name = e.loc.length > 1 && e.loc[0] === 'body' ? String(e.loc[1]) : null;
    if (name && known.has(name)) fields.set(name, [...(fields.get(name) ?? []), e.msg]);
  }
  const byCode = codeFields[error.code];
  if (byCode) fields.set(byCode, [problemMessage(error)]);

  if (fields.size === 0) return false;
  form.setFields([...fields].map(([name, errors]) => ({ name, errors })));
  return true;
}

/** Текст ошибки для общего сообщения (toast) — на языке интерфейса. */
export function problemText(error: unknown): string {
  return problemMessage(error);
}
